{
  "listConfig": {
    "dataSource1": [
      "Service Requests"
    ],
    "dataSource2": [
      "Add New WC Posting Notice Request"
    ]
  }
}
